/* section-message-action.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./section-message-action.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment, memo } from 'react';
import Button from '@atlaskit/button/standard-button';
import { cx } from '@atlaskit/css';
import Link from '@atlaskit/link';
import { fg } from '@atlaskit/platform-feature-flags';
import { Anchor, Box, Pressable } from '@atlaskit/primitives/compiled';
var stylesOld = {
  common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
  anchor: "_1053w7te _9oik1r31 _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
  pressable: "_bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1"
};
var styles = {
  common: "_11c82smr",
  anchor: "_k48pi7a9",
  pressable: "_syaz14q2 _k48p1wq8 _bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};

/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */
var SectionMessageAction = /*#__PURE__*/memo(function SectionMessageAction(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    href = _ref.href,
    testId = _ref.testId,
    linkComponent = _ref.linkComponent,
    target = _ref.target;
  if (!linkComponent && fg('platform_section_message_action_migration')) {
    if (href) {
      if (fg('platform_dst_section_message_actions_as_link')) {
        return /*#__PURE__*/React.createElement("span", {
          className: ax([styles.common, styles.anchor])
        }, /*#__PURE__*/React.createElement(Link, {
          testId: testId,
          onClick: onClick,
          href: href,
          target: target
        }, children));
      }
      return /*#__PURE__*/React.createElement(Anchor, {
        testId: testId,
        onClick: onClick,
        href: href,
        xcss: cx(stylesOld.common, stylesOld.anchor)
      }, children);
    }
    if (onClick) {
      return /*#__PURE__*/React.createElement(Pressable, {
        testId: testId,
        onClick: onClick,
        xcss: cx(fg('platform_dst_section_message_actions_as_link') ? styles.common : stylesOld.common, fg('platform_dst_section_message_actions_as_link') ? styles.pressable : stylesOld.pressable)
      }, children);
    }
    return /*#__PURE__*/React.createElement(Box, {
      as: "span",
      testId: testId,
      xcss: fg('platform_dst_section_message_actions_as_link') && styles.common
    }, children);
  }
  return onClick || href ? /*#__PURE__*/React.createElement(Button, {
    testId: testId,
    appearance: "link",
    spacing: "none",
    onClick: onClick,
    href: href,
    component: href ? linkComponent : undefined
  }, children) : /*#__PURE__*/React.createElement(Fragment, null, children);
});
export default SectionMessageAction;